import { useApi } from '~/composables/useApi';

export const useUserSelectorApi = () => {
  // 사용자 목록 조회
  const fetchUserList = (params: {
    compId: string;
    findYear: string;
    retireViewYn?: string;
    userNm?: string;
    deptId?: string;
    findPosId?: string;
    findJikgubId?: string;
  }) => {
    return useApi('/api/common/userList_json.do', {
      method: 'POST',
      query: params,
      skipLoading: true,
    });
  };

  const fetchUserInsaList = (params: {
    findYear: string;
    deptId: string;
    userNm?: string;
    evalCycleCd: string;
    userIdYn?: string;
  }) => {
    return useApi('/api/common/userInsaList_json.do', {
      method: 'POST',
      query: params,
      skipLoading: true,
    });
  };

  // 부서 목록 조회
  const fetchDeptList = (params: { findCompId: string }) => {
    const urlParams = new URLSearchParams();
    urlParams.append('findCompId', params.findCompId);

    return useApi('/api/common/deptList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: urlParams.toString(),
      skipLoading: true,
    });
  };

  const fetchDeptInsaList = (params: { findYear: string; evalCycleCd: string }) => {
    const urlParams = new URLSearchParams();
    urlParams.append('findYear', params.findYear);
    urlParams.append('evalCycleCd', params.evalCycleCd);

    return useApi('/api/common/deptInsaList_json.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: urlParams.toString(),
      skipLoading: true,
    });
  };

  return {
    fetchUserList,
    fetchUserInsaList,
    fetchDeptList,
    fetchDeptInsaList,
  };
};
